// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DoctorAvailabilityComponent.css */

/* Ensure the container has padding and background styling */
.custom-availability-container {
    margin: 2rem;
    padding: 20px;
    background-color: white;
    border: 3px solid var(--clr-primary-3);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Header for the availability section */
.custom-availability-header {
    text-align: center;
    color: var(--clr-primary-5); 
    font-weight: 600;
}

/* Styling for the availability section */
.availability-section {
  text-align: center;
  margin-bottom: 20px; /* Space between the section and the next element */
}

.availability-description {
  max-width: 1230px; 
  margin: 0 auto; 
  font-size: 1rem; 
  line-height: 1.6; 
  color: var(--clr-primary-6)
}

/* Styling specifically for the paragraph inside the description */
.availability-description p {
  margin: 10px 0; 
  padding: 10px; 
  background-color:var(--clr-primary-6);
  border-radius: 8px; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-weight: 400; 
  color: var(--clr-white);
}

/* Style for saved slots section */
.custom-saved-slots {
    margin-top: 20px;
}

.custom-saved-slots h3 {
    color: var(--clr-primary-5); 
}

/* Style for the saved slots list */
.custom-saved-slots ul {
    list-style-type: none;
    padding: 0;
}

.custom-saved-slots li {
    margin-bottom: 10px;
    font-size: 16px;
}

/* Style for the delete button in saved slots */
.custom-saved-slots button {
    background-color: var(--red-dark); 
    color: var(--clr-white);
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    margin-left: 10px;
    cursor: pointer;
}

/* Ensure the calendar looks clean */
.custom-availability-calendar {
    border-radius: 8px;
    border: 1px solid var(--clr-primary-5); 
    overflow: hidden;
    cursor: default;
}

.custom-availability-calendar .rbc-event {
    cursor: pointer; /* Ensure pointer appears for events */
  }

/* Available slots with gradient */
.custom-availability-container .rbc-event-available {
    /* background: linear-gradient(135deg, hsl(145, 70%, 42%), hsl(145, 80%, 50%)) !important;  */
    color: var(--clr-white);
    padding: 5px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.9rem; 
    box-shadow: var(--shadow-1);
    transition: transform 0.3s ease;
}

/* Unavailable slots with gradient */
.custom-availability-container .rbc-event-unavailable {
    /* background: linear-gradient(135deg, hsl(0, 70%, 55%), hsl(0, 80%, 60%)) !important;  */
    color: var(--clr-white);
    padding: 5px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.9rem; 
    box-shadow: var(--shadow-1);
    transition: transform 0.3s ease;
}

/* Lighter color gradient for past slots */
.custom-availability-container .rbc-event-past {
    /* background: linear-gradient(135deg, hsl(0, 10%, 85%), hsl(0, 5%, 90%)) !important;  */
    color: var(--clr-grey-5); 
    padding: 5px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.9rem;
    box-shadow: var(--shadow-1);
    opacity: 0.7; 
    transition: transform 0.3s ease;
}

/* Hover effect for events */
.custom-availability-container .rbc-event-available:hover,
.custom-availability-container .rbc-event-unavailable:hover {
    transform: scale(1.05);
    box-shadow: var(--shadow-4);
}

/* Reduced overall cell size for better fit with multiple events */
.custom-availability-calendar .rbc-day-slot {
    min-height: 80px; 
}

/* Reduced font size for better layout with multiple events */
.custom-availability-container .rbc-event {
    font-size: 0.85rem;
}

/* Override .rbc-event styles specifically for DoctorAvailabilityComponent */
.custom-availability-container .rbc-event {
    background-image: none !important; 
    color: #fff; 
    padding: 5px;
    border-radius: 4px;
    box-shadow: none !important; 
}

/* Tooltip Styles */
.custom-availability-container .rbc-event-tooltip {
    font-size: 0.85rem;
    color: var(--clr-grey-3);
}

/* Different hover effect for availability component (optional) */
.custom-availability-container .rbc-event:hover {
    transform: none !important;
    box-shadow: none !important;
}

/* Tooltip adjustments */
.custom-availability-container .rbc-event-tooltip {
    font-size: 0.85rem;
    padding: 8px;
    background: #000;
    color: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

/* Container for the entire My Schedule Overview section */
.custom-schedule-overview-container {
    padding: 20px;
    background-color: #f4f7f9;
    border-radius: 10px;
    border: 1px solid var(--clr-primary-5);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    margin: 30px 0;
}
  
/* Header for the schedule overview */
.custom-schedule-header {
font-size: 1.6rem;
color: var(--clr-primary-5);
margin-bottom: 20px;
text-align: center;
font-weight: 600;
}
  
/* Toggle Buttons */
.custom-schedule-toggle {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
  
.custom-toggle-button {
    padding: 10px 20px;
    font-size: 1rem;
    border: 2px solid var(--clr-primary-5);
    border-radius: 2rem;
    background-color: var(--clr-primary-9);
    color: var(--clr-primary-1);
    cursor: pointer;
    transition: all 0.3s ease;
    margin: 0 10px;
}
  
/* Active Toggle Button */
.custom-toggle-button.active {
    background-color: var(--clr-primary-7);
    color: white;
    font-weight: bold;
}
  
/* Hover Effect for Buttons */
.custom-toggle-button:hover {
    background-color: var(--clr-primary-5);
    color: white;
    border-color: var(--clr-primary-7);
}


  /* Subheader for each section */
.custom-schedule-subheader {
    font-size: 1.5rem; 
    color: var(--clr-grey-1);
    margin-bottom: 20px;
    position: relative; 
    padding-bottom: 12px;
    letter-spacing: 0.05rem; 
    text-align: center;
    /* font-weight: 700;  */
}

/* Adding a more stylish underline effect */
.custom-schedule-subheader::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px; 
    height: 4px; 
    background-color: var(--clr-grey-3);
    border-radius: 2px; 
}

/* Optional hover effect for more engagement */
.custom-schedule-subheader:hover {
    color: var(--clr-primary-3); 
}

.custom-schedule-subheader:hover::after {
    background-color: var(--clr-primary-3); 
    width: 100px; 
}

  
/* Slots grid */
.custom-schedule-slots-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
    max-height: 300px; 
    overflow-y: auto;  
    padding-right: 10px; 
}
  
  /* Individual slot */
.custom-schedule-slot {
    padding: 0.5px;
    border-radius: 8px;
    background-color: var(--clr-grey-10);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: var(--shadow-1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}
  
.custom-schedule-slot.available {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
}

.custom-schedule-slot.unavailable {
    background-color: var(--red-light);
    color: var(--clr-white);
}

.custom-schedule-slot:hover {
    transform: scale(1.05);
    box-shadow: var(--shadow-3);
  }
  
/* Slot time */
.custom-slot-time {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 8px;
}

/* Slot status */
.custom-slot-status {
    font-size: 0.9rem;
    font-weight: 500;
}

/* No availability message container */
.custom-no-availability-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%; 
    min-height: 150px; 
  }
  
/* No availability message styling */
.custom-no-availability-message {
    font-size: 1rem;
    color: var(--clr-grey-3); 
    text-align: center;
    padding: 15px 20px; 
    background-color: var(--red-light); 
    border-radius: 8px; 
    border: 2px solid var(--clr-primary-5); 
    width: fit-content; 
    white-space: nowrap; 
    margin: 20px auto; 
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); 
    font-weight: 500; 
    letter-spacing: 0.02em; 
    transition: transform 0.2s ease, background-color 0.2s ease; 
}

/* Hover effect */
.custom-no-availability-message:hover {
    background-color: var(--clr-grey-8); 
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15); 
    transform: scale(1.02); 
}

.doctor-fetch-container {
    max-width: 850px; 
    margin: 2rem auto;
    padding: 1.5rem;
    background-color: var(--clr-white);
    border: 1px solid var(--clr-primary-5);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    font-family: var(--ff-primary);
  }
  
  .doctor-role-message {
    margin-bottom: 1.5rem;
    font-size: 1rem;
    color: var(--clr-grey-3);
    text-align: center; 
  }
  
  .doctor-role-message strong {
    color: var(--clr-primary-5);
  }
  
  .clinic-name {
    font-weight: bold;
    color: var(--clr-primary-5);
  }
  
  .role-based-actions {
    margin-top: 1rem;
    display: flex;
    flex-direction: column; 
    align-items: center;
    gap: 1rem; 
  }
  
  .practitioner-selection {
    width: 100%; 
    max-width: 500px; 
    margin: 1rem auto; 
    padding: 1rem; 
    border: 1px solid var(--grey-300); 
    border-radius: var(--radius); 
    background-color: var(--clr-white); 
    box-shadow: var(--light-shadow); 
    text-align: left; 
  }
  
  .practitioner-selection p {
    margin-bottom: 0.5rem; 
    font-size: var(--small-text); 
    color: var(--clr-grey-4); 
  }
  
  /* Dropdown Styles */
  .practitioner-dropdown {
    width: 100%; 
    max-height: 200px; 
    padding: 0.6rem; 
    border: 1px solid var(--grey-300); 
    border-radius: var(--radius); 
    font-size: 1rem; 
    background-color: var(--grey-100); 
    color: var(--clr-grey-3); 
    transition: var(--transition); 
    appearance: none;
    cursor: pointer; 
    font-family: var(--ff-primary); 
    overflow-y: auto; 
  }
  
  /* Hover & Focus Styles */
  .practitioner-dropdown:hover,
  .practitioner-dropdown:focus {
    border-color: var(--clr-primary-5); 
    outline: none; 
    box-shadow: 0 0 8px var(--clr-primary-5); /* Slightly darker grey */
  }
  
  /* Scrollable Dropdown Panel */
  .practitioner-dropdown optgroup,
  .practitioner-dropdown option {
    padding: 0.5rem; 
    color: var(--clr-grey-4); 
    background-color: var(--clr-white); 
  }
  
  .practitioner-dropdown:focus-visible {
    overflow-y: auto; 
    max-height: 10rem; 
    background-color: var(--clr-white); 
    z-index: 1000; 
  }
  
  /* Disabled State */
  .practitioner-dropdown:disabled {
    background-color: var(--grey-300); 
    color: var(--grey-500); 
    border-color: var(--grey-400); 
    cursor: not-allowed; 
  }
  
  
  .error-message {
    color: var(--red-dark);
    font-size: var(--extra-small-text);
    margin-top: 0.5rem;
  }

  .selected-practitioner-details{
    padding: 1.25rem;
  }
    .selected-practitioner-details,
    .all-marked-slots-message {
    margin-top: 1.5rem;
    /* padding: 1.25rem;  */
    background-color: var(--grey-100); 
    border: 1px solid var(--grey-300); 
    border-radius: var(--radius);
    box-shadow: var(--shadow-2); 
    text-align: center;
    transition: var(--transition); 
    }

    .selected-practitioner-details:hover,
    .all-marked-slots-message:hover {
    background-color: var(--grey-200); 
    box-shadow: var(--shadow-3); 
    }

    .selected-practitioner-details h4,
    .all-marked-slots-message h4 {
    margin: 0 0 0.75rem; 
    font-size: 1.2rem; 
    color: var(--clr-grey-2);
    text-transform: capitalize; 
    }

    .selected-practitioner-details p,
    .all-marked-slots-message p {
    margin: 0.5rem 0; 
    font-size: var(--small-text);
    color: var(--clr-grey-5);
    line-height: 1.6; 
    }

  
  .selected-practitioner-details p {
    margin: 0.25rem 0;
    font-size: var(--small-text);
    color: var(--clr-grey-5);
  }
  
  .calendar-legend {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    flex-wrap: wrap; 
    gap: 1.5rem; 
    margin-top: 2rem;
    margin-bottom: 1rem;
    padding: 1rem 1.5rem; 
    background-color: var(--grey-100); 
    border-radius: var(--radius); 
    box-shadow: var(--light-shadow); 
    text-align: center;
    border: 1px solid var(--grey-300); 
  }
  
  .legend-item {
    display: flex;
    align-items: center;
    gap: 0.75rem; 
  }
  
  .legend-color {
    width: 1.2rem; 
    height: 1.2rem;
    border-radius: 50%; 
    box-shadow: var(--shadow-2); 
    border: 1px solid var(--grey-400); 
  }
  
  .legend-item span {
    font-size: var(--small-text); 
    font-weight: 500; 
    color: var(--clr-grey-2); 
  }

  /* Responsive design for toggle buttons */
  @media (max-width: 768px) {
    .custom-schedule-toggle {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
  
    .custom-toggle-button {
      width: 100%;
      padding: 8px 15px;
      font-size: 0.9rem;
      margin: 5px 0;
    }
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .custom-no-availability-message {
      font-size: 0.9rem; 
      padding: 10px 15px; 
      white-space: normal; 
      width: 90%; 
    }
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .custom-schedule-slots-grid {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      max-height: 400px; 
    }
  
    .custom-toggle-button {
      padding: 8px 15px;
      font-size: 0.9rem;
    }
  }
  
  
  /* Responsive Design */
  @media screen and (max-width: 768px) {
    .doctor-fetch-container {
      padding: 1rem;
    }
  
    .role-based-actions {
      gap: 0.5rem;
    }
  
    .calendar-legend {
      flex-direction: column; /* Stack items vertically on smaller screens */
      align-items: flex-start; /* Align items to the left */
      padding: 1rem; /* Adjust padding */
      gap: 1rem; /* Maintain spacing */
    }
  
    .legend-item {
      gap: 0.5rem; /* Adjust gap for compact view */
    }
  
    .legend-item span {
      font-size: var(--extra-small-text); /* Adjust text size for readability */
    }

    .practitioner-selection p {
      font-size: var(--extra-small-text);
    }
  
    .practitioner-dropdown {
      padding: 0.6rem;
      font-size: var(--small-text);
    }

  
    .practitioner-selection {
      width: 90%; /* Adjust container width */
      padding: 0.8rem; /* Adjust padding */
    }
  
    .practitioner-dropdown {
      font-size: 0.9rem; /* Reduce font size for smaller screens */
      padding: 0.6rem; /* Adjust padding */
    }
  
    .selected-practitioner-details,
    .all-marked-slots-message {
        padding: 1rem; /* Reduce padding for smaller screens */
        margin-top: 1rem; /* Reduce margin to save space */
    }
      
    .selected-practitioner-details h4,
    .all-marked-slots-message h4 {
        font-size: 1rem; /* Adjust font size for smaller devices */
    }
    
    .selected-practitioner-details p,
    .all-marked-slots-message p {
        font-size: 0.85rem; /* Reduce font size for smaller screens */
        line-height: 1.4; /* Maintain readability */
    }
      
    }
  `, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/DoctorAvailabilityComponent.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,4DAA4D;AAC5D;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,mBAAmB,EAAE,mDAAmD;AAC1E;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA,kEAAkE;AAClE;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,mCAAmC;AACnC;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA,+CAA+C;AAC/C;IACI,iCAAiC;IACjC,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe,EAAE,sCAAsC;EACzD;;AAEF,kCAAkC;AAClC;IACI,6FAA6F;IAC7F,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA,oCAAoC;AACpC;IACI,yFAAyF;IACzF,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA,0CAA0C;AAC1C;IACI,wFAAwF;IACxF,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,+BAA+B;AACnC;;AAEA,4BAA4B;AAC5B;;IAEI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,kEAAkE;AAClE;IACI,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,kBAAkB;AACtB;;AAEA,4EAA4E;AAC5E;IACI,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA,iEAAiE;AACjE;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;IACtC,yCAAyC;IACzC,cAAc;AAClB;;AAEA,qCAAqC;AACrC;AACA,iBAAiB;AACjB,2BAA2B;AAC3B,mBAAmB;AACnB,kBAAkB;AAClB,gBAAgB;AAChB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,sCAAsC;IACtC,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,sCAAsC;IACtC,YAAY;IACZ,kCAAkC;AACtC;;;EAGE,+BAA+B;AACjC;IACI,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,2CAA2C;AAC3C;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA,8CAA8C;AAC9C;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;;AAGA,eAAe;AACf;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;EAEE,oBAAoB;AACtB;IACI,cAAc;IACd,kBAAkB;IAClB,oCAAoC;IACpC,qDAAqD;IACrD,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;EAC7B;;AAEF,cAAc;AACd;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;AAEF,oCAAoC;AACpC;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,2CAA2C;IAC3C,gBAAgB;IAChB,sBAAsB;IACtB,2DAA2D;AAC/D;;AAEA,iBAAiB;AACjB;IACI,mCAAmC;IACnC,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,sCAAsC;IACtC,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,iCAAiC;IACjC,4BAA4B;IAC5B,kCAAkC;IAClC,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,4BAA4B;IAC5B,eAAe;IACf,iCAAiC;IACjC,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;;IAEE,kCAAkC;IAClC,aAAa;IACb,wCAAwC,EAAE,yBAAyB;EACrE;;EAEA,8BAA8B;EAC9B;;IAEE,eAAe;IACf,wBAAwB;IACxB,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,aAAa;EACf;;EAEA,mBAAmB;EACnB;IACE,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;EACrB;;;EAGA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;IACE;;IAEA,kBAAkB;IAClB,uBAAuB;IACvB,iCAAiC;IACjC,iCAAiC;IACjC,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,6BAA6B;IAC7B;;IAEA;;IAEA,iCAAiC;IACjC,2BAA2B;IAC3B;;IAEA;;IAEA,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;IACxB,0BAA0B;IAC1B;;IAEA;;IAEA,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;IAChB;;;EAGF;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iCAAiC;IACjC,4BAA4B;IAC5B,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA,yCAAyC;EACzC;IACE;MACE,sBAAsB;MACtB,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,iBAAiB;MACjB,iBAAiB;MACjB,aAAa;IACf;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,UAAU;IACZ;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,4DAA4D;MAC5D,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;;EAGA,sBAAsB;EACtB;IACE;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,sBAAsB,EAAE,8CAA8C;MACtE,uBAAuB,EAAE,4BAA4B;MACrD,aAAa,EAAE,mBAAmB;MAClC,SAAS,EAAE,qBAAqB;IAClC;;IAEA;MACE,WAAW,EAAE,gCAAgC;IAC/C;;IAEA;MACE,kCAAkC,EAAE,qCAAqC;IAC3E;;IAEA;MACE,kCAAkC;IACpC;;IAEA;MACE,eAAe;MACf,4BAA4B;IAC9B;;;IAGA;MACE,UAAU,EAAE,2BAA2B;MACvC,eAAe,EAAE,mBAAmB;IACtC;;IAEA;MACE,iBAAiB,EAAE,yCAAyC;MAC5D,eAAe,EAAE,mBAAmB;IACtC;;IAEA;;QAEI,aAAa,EAAE,uCAAuC;QACtD,gBAAgB,EAAE,gCAAgC;IACtD;;IAEA;;QAEI,eAAe,EAAE,yCAAyC;IAC9D;;IAEA;;QAEI,kBAAkB,EAAE,yCAAyC;QAC7D,gBAAgB,EAAE,yBAAyB;IAC/C;;IAEA","sourcesContent":["/* DoctorAvailabilityComponent.css */\n\n/* Ensure the container has padding and background styling */\n.custom-availability-container {\n    margin: 2rem;\n    padding: 20px;\n    background-color: white;\n    border: 3px solid var(--clr-primary-3);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Header for the availability section */\n.custom-availability-header {\n    text-align: center;\n    color: var(--clr-primary-5); \n    font-weight: 600;\n}\n\n/* Styling for the availability section */\n.availability-section {\n  text-align: center;\n  margin-bottom: 20px; /* Space between the section and the next element */\n}\n\n.availability-description {\n  max-width: 1230px; \n  margin: 0 auto; \n  font-size: 1rem; \n  line-height: 1.6; \n  color: var(--clr-primary-6)\n}\n\n/* Styling specifically for the paragraph inside the description */\n.availability-description p {\n  margin: 10px 0; \n  padding: 10px; \n  background-color:var(--clr-primary-6);\n  border-radius: 8px; \n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  font-weight: 400; \n  color: var(--clr-white);\n}\n\n/* Style for saved slots section */\n.custom-saved-slots {\n    margin-top: 20px;\n}\n\n.custom-saved-slots h3 {\n    color: var(--clr-primary-5); \n}\n\n/* Style for the saved slots list */\n.custom-saved-slots ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.custom-saved-slots li {\n    margin-bottom: 10px;\n    font-size: 16px;\n}\n\n/* Style for the delete button in saved slots */\n.custom-saved-slots button {\n    background-color: var(--red-dark); \n    color: var(--clr-white);\n    border: none;\n    padding: 5px 10px;\n    border-radius: 5px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n\n/* Ensure the calendar looks clean */\n.custom-availability-calendar {\n    border-radius: 8px;\n    border: 1px solid var(--clr-primary-5); \n    overflow: hidden;\n    cursor: default;\n}\n\n.custom-availability-calendar .rbc-event {\n    cursor: pointer; /* Ensure pointer appears for events */\n  }\n\n/* Available slots with gradient */\n.custom-availability-container .rbc-event-available {\n    /* background: linear-gradient(135deg, hsl(145, 70%, 42%), hsl(145, 80%, 50%)) !important;  */\n    color: var(--clr-white);\n    padding: 5px;\n    border-radius: 6px;\n    font-weight: 600;\n    font-size: 0.9rem; \n    box-shadow: var(--shadow-1);\n    transition: transform 0.3s ease;\n}\n\n/* Unavailable slots with gradient */\n.custom-availability-container .rbc-event-unavailable {\n    /* background: linear-gradient(135deg, hsl(0, 70%, 55%), hsl(0, 80%, 60%)) !important;  */\n    color: var(--clr-white);\n    padding: 5px;\n    border-radius: 6px;\n    font-weight: 600;\n    font-size: 0.9rem; \n    box-shadow: var(--shadow-1);\n    transition: transform 0.3s ease;\n}\n\n/* Lighter color gradient for past slots */\n.custom-availability-container .rbc-event-past {\n    /* background: linear-gradient(135deg, hsl(0, 10%, 85%), hsl(0, 5%, 90%)) !important;  */\n    color: var(--clr-grey-5); \n    padding: 5px;\n    border-radius: 6px;\n    font-weight: 600;\n    font-size: 0.9rem;\n    box-shadow: var(--shadow-1);\n    opacity: 0.7; \n    transition: transform 0.3s ease;\n}\n\n/* Hover effect for events */\n.custom-availability-container .rbc-event-available:hover,\n.custom-availability-container .rbc-event-unavailable:hover {\n    transform: scale(1.05);\n    box-shadow: var(--shadow-4);\n}\n\n/* Reduced overall cell size for better fit with multiple events */\n.custom-availability-calendar .rbc-day-slot {\n    min-height: 80px; \n}\n\n/* Reduced font size for better layout with multiple events */\n.custom-availability-container .rbc-event {\n    font-size: 0.85rem;\n}\n\n/* Override .rbc-event styles specifically for DoctorAvailabilityComponent */\n.custom-availability-container .rbc-event {\n    background-image: none !important; \n    color: #fff; \n    padding: 5px;\n    border-radius: 4px;\n    box-shadow: none !important; \n}\n\n/* Tooltip Styles */\n.custom-availability-container .rbc-event-tooltip {\n    font-size: 0.85rem;\n    color: var(--clr-grey-3);\n}\n\n/* Different hover effect for availability component (optional) */\n.custom-availability-container .rbc-event:hover {\n    transform: none !important;\n    box-shadow: none !important;\n}\n\n/* Tooltip adjustments */\n.custom-availability-container .rbc-event-tooltip {\n    font-size: 0.85rem;\n    padding: 8px;\n    background: #000;\n    color: #fff;\n    border-radius: 4px;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Container for the entire My Schedule Overview section */\n.custom-schedule-overview-container {\n    padding: 20px;\n    background-color: #f4f7f9;\n    border-radius: 10px;\n    border: 1px solid var(--clr-primary-5);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    margin: 30px 0;\n}\n  \n/* Header for the schedule overview */\n.custom-schedule-header {\nfont-size: 1.6rem;\ncolor: var(--clr-primary-5);\nmargin-bottom: 20px;\ntext-align: center;\nfont-weight: 600;\n}\n  \n/* Toggle Buttons */\n.custom-schedule-toggle {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n  \n.custom-toggle-button {\n    padding: 10px 20px;\n    font-size: 1rem;\n    border: 2px solid var(--clr-primary-5);\n    border-radius: 2rem;\n    background-color: var(--clr-primary-9);\n    color: var(--clr-primary-1);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin: 0 10px;\n}\n  \n/* Active Toggle Button */\n.custom-toggle-button.active {\n    background-color: var(--clr-primary-7);\n    color: white;\n    font-weight: bold;\n}\n  \n/* Hover Effect for Buttons */\n.custom-toggle-button:hover {\n    background-color: var(--clr-primary-5);\n    color: white;\n    border-color: var(--clr-primary-7);\n}\n\n\n  /* Subheader for each section */\n.custom-schedule-subheader {\n    font-size: 1.5rem; \n    color: var(--clr-grey-1);\n    margin-bottom: 20px;\n    position: relative; \n    padding-bottom: 12px;\n    letter-spacing: 0.05rem; \n    text-align: center;\n    /* font-weight: 700;  */\n}\n\n/* Adding a more stylish underline effect */\n.custom-schedule-subheader::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 80px; \n    height: 4px; \n    background-color: var(--clr-grey-3);\n    border-radius: 2px; \n}\n\n/* Optional hover effect for more engagement */\n.custom-schedule-subheader:hover {\n    color: var(--clr-primary-3); \n}\n\n.custom-schedule-subheader:hover::after {\n    background-color: var(--clr-primary-3); \n    width: 100px; \n}\n\n  \n/* Slots grid */\n.custom-schedule-slots-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 15px;\n    max-height: 300px; \n    overflow-y: auto;  \n    padding-right: 10px; \n}\n  \n  /* Individual slot */\n.custom-schedule-slot {\n    padding: 0.5px;\n    border-radius: 8px;\n    background-color: var(--clr-grey-10);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    box-shadow: var(--shadow-1);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n  \n.custom-schedule-slot.available {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n}\n\n.custom-schedule-slot.unavailable {\n    background-color: var(--red-light);\n    color: var(--clr-white);\n}\n\n.custom-schedule-slot:hover {\n    transform: scale(1.05);\n    box-shadow: var(--shadow-3);\n  }\n  \n/* Slot time */\n.custom-slot-time {\n    font-size: 1rem;\n    font-weight: bold;\n    margin-bottom: 8px;\n}\n\n/* Slot status */\n.custom-slot-status {\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n/* No availability message container */\n.custom-no-availability-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%; \n    min-height: 150px; \n  }\n  \n/* No availability message styling */\n.custom-no-availability-message {\n    font-size: 1rem;\n    color: var(--clr-grey-3); \n    text-align: center;\n    padding: 15px 20px; \n    background-color: var(--red-light); \n    border-radius: 8px; \n    border: 2px solid var(--clr-primary-5); \n    width: fit-content; \n    white-space: nowrap; \n    margin: 20px auto; \n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); \n    font-weight: 500; \n    letter-spacing: 0.02em; \n    transition: transform 0.2s ease, background-color 0.2s ease; \n}\n\n/* Hover effect */\n.custom-no-availability-message:hover {\n    background-color: var(--clr-grey-8); \n    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15); \n    transform: scale(1.02); \n}\n\n.doctor-fetch-container {\n    max-width: 850px; \n    margin: 2rem auto;\n    padding: 1.5rem;\n    background-color: var(--clr-white);\n    border: 1px solid var(--clr-primary-5);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    font-family: var(--ff-primary);\n  }\n  \n  .doctor-role-message {\n    margin-bottom: 1.5rem;\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    text-align: center; \n  }\n  \n  .doctor-role-message strong {\n    color: var(--clr-primary-5);\n  }\n  \n  .clinic-name {\n    font-weight: bold;\n    color: var(--clr-primary-5);\n  }\n  \n  .role-based-actions {\n    margin-top: 1rem;\n    display: flex;\n    flex-direction: column; \n    align-items: center;\n    gap: 1rem; \n  }\n  \n  .practitioner-selection {\n    width: 100%; \n    max-width: 500px; \n    margin: 1rem auto; \n    padding: 1rem; \n    border: 1px solid var(--grey-300); \n    border-radius: var(--radius); \n    background-color: var(--clr-white); \n    box-shadow: var(--light-shadow); \n    text-align: left; \n  }\n  \n  .practitioner-selection p {\n    margin-bottom: 0.5rem; \n    font-size: var(--small-text); \n    color: var(--clr-grey-4); \n  }\n  \n  /* Dropdown Styles */\n  .practitioner-dropdown {\n    width: 100%; \n    max-height: 200px; \n    padding: 0.6rem; \n    border: 1px solid var(--grey-300); \n    border-radius: var(--radius); \n    font-size: 1rem; \n    background-color: var(--grey-100); \n    color: var(--clr-grey-3); \n    transition: var(--transition); \n    appearance: none;\n    cursor: pointer; \n    font-family: var(--ff-primary); \n    overflow-y: auto; \n  }\n  \n  /* Hover & Focus Styles */\n  .practitioner-dropdown:hover,\n  .practitioner-dropdown:focus {\n    border-color: var(--clr-primary-5); \n    outline: none; \n    box-shadow: 0 0 8px var(--clr-primary-5); /* Slightly darker grey */\n  }\n  \n  /* Scrollable Dropdown Panel */\n  .practitioner-dropdown optgroup,\n  .practitioner-dropdown option {\n    padding: 0.5rem; \n    color: var(--clr-grey-4); \n    background-color: var(--clr-white); \n  }\n  \n  .practitioner-dropdown:focus-visible {\n    overflow-y: auto; \n    max-height: 10rem; \n    background-color: var(--clr-white); \n    z-index: 1000; \n  }\n  \n  /* Disabled State */\n  .practitioner-dropdown:disabled {\n    background-color: var(--grey-300); \n    color: var(--grey-500); \n    border-color: var(--grey-400); \n    cursor: not-allowed; \n  }\n  \n  \n  .error-message {\n    color: var(--red-dark);\n    font-size: var(--extra-small-text);\n    margin-top: 0.5rem;\n  }\n\n  .selected-practitioner-details{\n    padding: 1.25rem;\n  }\n    .selected-practitioner-details,\n    .all-marked-slots-message {\n    margin-top: 1.5rem;\n    /* padding: 1.25rem;  */\n    background-color: var(--grey-100); \n    border: 1px solid var(--grey-300); \n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2); \n    text-align: center;\n    transition: var(--transition); \n    }\n\n    .selected-practitioner-details:hover,\n    .all-marked-slots-message:hover {\n    background-color: var(--grey-200); \n    box-shadow: var(--shadow-3); \n    }\n\n    .selected-practitioner-details h4,\n    .all-marked-slots-message h4 {\n    margin: 0 0 0.75rem; \n    font-size: 1.2rem; \n    color: var(--clr-grey-2);\n    text-transform: capitalize; \n    }\n\n    .selected-practitioner-details p,\n    .all-marked-slots-message p {\n    margin: 0.5rem 0; \n    font-size: var(--small-text);\n    color: var(--clr-grey-5);\n    line-height: 1.6; \n    }\n\n  \n  .selected-practitioner-details p {\n    margin: 0.25rem 0;\n    font-size: var(--small-text);\n    color: var(--clr-grey-5);\n  }\n  \n  .calendar-legend {\n    display: flex;\n    /* justify-content: space-between; */\n    align-items: center;\n    flex-wrap: wrap; \n    gap: 1.5rem; \n    margin-top: 2rem;\n    margin-bottom: 1rem;\n    padding: 1rem 1.5rem; \n    background-color: var(--grey-100); \n    border-radius: var(--radius); \n    box-shadow: var(--light-shadow); \n    text-align: center;\n    border: 1px solid var(--grey-300); \n  }\n  \n  .legend-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem; \n  }\n  \n  .legend-color {\n    width: 1.2rem; \n    height: 1.2rem;\n    border-radius: 50%; \n    box-shadow: var(--shadow-2); \n    border: 1px solid var(--grey-400); \n  }\n  \n  .legend-item span {\n    font-size: var(--small-text); \n    font-weight: 500; \n    color: var(--clr-grey-2); \n  }\n\n  /* Responsive design for toggle buttons */\n  @media (max-width: 768px) {\n    .custom-schedule-toggle {\n      flex-direction: column;\n      align-items: center;\n      gap: 10px;\n    }\n  \n    .custom-toggle-button {\n      width: 100%;\n      padding: 8px 15px;\n      font-size: 0.9rem;\n      margin: 5px 0;\n    }\n  }\n  \n  /* Responsive design */\n  @media (max-width: 768px) {\n    .custom-no-availability-message {\n      font-size: 0.9rem; \n      padding: 10px 15px; \n      white-space: normal; \n      width: 90%; \n    }\n  }\n  \n  /* Responsive design */\n  @media (max-width: 768px) {\n    .custom-schedule-slots-grid {\n      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n      max-height: 400px; \n    }\n  \n    .custom-toggle-button {\n      padding: 8px 15px;\n      font-size: 0.9rem;\n    }\n  }\n  \n  \n  /* Responsive Design */\n  @media screen and (max-width: 768px) {\n    .doctor-fetch-container {\n      padding: 1rem;\n    }\n  \n    .role-based-actions {\n      gap: 0.5rem;\n    }\n  \n    .calendar-legend {\n      flex-direction: column; /* Stack items vertically on smaller screens */\n      align-items: flex-start; /* Align items to the left */\n      padding: 1rem; /* Adjust padding */\n      gap: 1rem; /* Maintain spacing */\n    }\n  \n    .legend-item {\n      gap: 0.5rem; /* Adjust gap for compact view */\n    }\n  \n    .legend-item span {\n      font-size: var(--extra-small-text); /* Adjust text size for readability */\n    }\n\n    .practitioner-selection p {\n      font-size: var(--extra-small-text);\n    }\n  \n    .practitioner-dropdown {\n      padding: 0.6rem;\n      font-size: var(--small-text);\n    }\n\n  \n    .practitioner-selection {\n      width: 90%; /* Adjust container width */\n      padding: 0.8rem; /* Adjust padding */\n    }\n  \n    .practitioner-dropdown {\n      font-size: 0.9rem; /* Reduce font size for smaller screens */\n      padding: 0.6rem; /* Adjust padding */\n    }\n  \n    .selected-practitioner-details,\n    .all-marked-slots-message {\n        padding: 1rem; /* Reduce padding for smaller screens */\n        margin-top: 1rem; /* Reduce margin to save space */\n    }\n      \n    .selected-practitioner-details h4,\n    .all-marked-slots-message h4 {\n        font-size: 1rem; /* Adjust font size for smaller devices */\n    }\n    \n    .selected-practitioner-details p,\n    .all-marked-slots-message p {\n        font-size: 0.85rem; /* Reduce font size for smaller screens */\n        line-height: 1.4; /* Maintain readability */\n    }\n      \n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
